<script>
    import { navigate }         from "svelte-routing"
    import { setContext }       from 'svelte'
    import _                    from 'lodash'
    import validate             from 'validate.js'    
    import saveAs               from 'file-saver'
    import * as api             from '../../shared/api.js'
    import { assignDuration }   from '../../shared/utils.js'
    import { company, domains } from '../../shared/stores.js'
    import { Inventory }        from '../../shared/inventory.js'
    import AppLoader            from '../../shared/Loader.svelte'
    import SectionTitle         from '../../shared/SectionTitle.svelte'
    import DomainDropdown       from '../../shared/DomainDropdown.svelte'
    import Issues               from '../../shared/Issues.svelte'
    import Versions             from './Versions.svelte'
    import Info                 from './Info.svelte'
    import Fields               from './Fields.svelte'
    import Integration          from './Integration.svelte'
    import PlaceFilter          from './PlaceFilter.svelte'
    import PlaceItem            from './PlaceItem.svelte'

    let active     = -1
    let domain     = null
    let inventory  = new Inventory(null)
    let version    = null
    let loading    = false
    let error      = false
    let archetype  = empty()
    let exporting  = false
    let filter     = () => true

    export let _domain  = false
    export let _company = false

    if(_domain) {
        domain = $domains.find(it => it.domain === _domain)
    }

    setContext('inventory', {
        get: () => inventory,
        set: json => {
            inventory = new Inventory(splitDurationAndUnit(json))
        }
    })
 
    validate.validators.unique = function(value, options, key, obj) {
        const same = places.find(p => p.id !== obj.id && p.identifier === value)
        return same && `O lugar '${same.name}' já usa o identificador '${value}'`
    }

    function splitDurationAndUnit(iv) {
        
        const fixField = field => {
            //console.log(field)
            const replacement = assignDuration(field, field.retention)
            delete replacement.retention
            return replacement
        }

        const splitThem = place => {
            if(place.fields) {
                place.fields = place.fields.map(fixField)
            }
            
            return place
        }

        if(iv && iv.places && iv.places.length > 0) {
            iv.places = iv.places.map(splitThem)
        }
        
        return iv
    }

    function onDomainSelected(selected) {
        const it = selected ? selected.value : null
        if(it) {
            navigate(`/empresa/${$company.id}/lugares/${it.domain}`)
            if(!domain || it.id !== domain.id) {
                domain = it
            }
        } else {
            navigate(`/empresa/${$company.id}/lugares`)
        }
    }

    function empty() {
        return { 
            id            : 0    ,
            name          : null ,
            kind          : null ,
            group         : null ,
            description   : null , 
            responsible   : null , 
            email         : null ,
            locator       : null ,
            fields        : [] 
        }
    }

    function loadBuffer(domain, version) {
        if(!domain) {
            inventory = new Inventory(null)
            return 
        }

        if(inventory.at(version)) {
            return
        }

        //console.log(domain, version)

        loading = true
        return api.get(`/inventory/domain/${domain.id}${ version ? '?at='+version : '' }`)
            .then(api.toJsonIf200)
            .then(json => {
                inventory = new Inventory(splitDurationAndUnit(json))
                loading   = false
                error     = false
                // items.forEach(console.log)
            })
            .catch(err => {
                loading = false
                error   = err
            })
    }

    function exportInventory() {
        const tag1 = version ? '?at='+version : ''
        const tag2 = version ? '-'+version    : ''
        exporting = true
        return api
                .get(`/inventory/domain/${domain.id}/export${tag1}`)
                .then(res => {
                    exporting = false
                    if(res.status === 200) {
                        res.blob().then(blob => {
                            saveAs(blob, `data-mapping-dogma-${domain.id}${tag2}`)
                        })
                    } else {
                        error   = true
                        message = 'Erro ao cadastrar'
                    }
                })
                .catch(err => {
                    console.log(err)
                    exporting = false
                })

    }

    $: loadBuffer(domain, version)
    $: places   = inventory.places()
    $: latest   = inventory.isLatest()
    $: issues   = inventory.placeIssues()
    $: filtered = inventory.placesMatching(filter)
</script>
{#if loading || error}
    <AppLoader {error} what="Carregando" inverted={true}/>
{:else}
    <SectionTitle>
        Dados e Lugares
    </SectionTitle>
    <div class="places">
        <DomainDropdown {domain} {onDomainSelected} />
        {#if domain}
            <div>
                <Versions {inventory} bind:version disabled={active > 0}/>
                <button 
                    class="ui blue button" 
                    class:disabled={exporting}
                    class:loading={exporting}
                    on:click={exportInventory}>Exportar</button>
            </div>
        {/if}
    </div>
    {#if !domain}
        <div class="ui big message">
            Selecione um domínio
        </div>
    {:else}
        <div class="ui raised segments">
            <div class="ui segment">
                <div class="places">
                    <h2 class="ui header">Lugares</h2>
                    <PlaceFilter {inventory} bind:filter></PlaceFilter>
                </div>
            </div>
            {#if issues.length > 0}
                <div class="ui  segment">
                    <Issues {issues}>
                        Problemas:
                    </Issues>
                </div>
            {/if}
            <PlaceItem
                bind:inventory
                bind:active
                bind:item={archetype}
                disabled={!latest || active > 0}
                {domain}
                {latest}
                {empty}>
            </PlaceItem>      
            {#each filtered as place (place.id)}
                <PlaceItem
                    bind:inventory
                    bind:active
                    bind:item={place}
                    disabled={!latest} 
                    {domain}
                    {latest}
                    {empty}>
                </PlaceItem>
            {/each}    
        </div>
    {/if}
{/if}

<style>
    .places {
        display: flex;
        justify-content: space-between;
    }
</style>
